<div class="icon-wrapper">
  @if (icon) {
    <img
      src="assets/images/notifications/{{icon}}.svg"
      [alt]="subtype"
      [style.height]="size()">
  }
  @if (chip) {
    <div class="notif-indicator" [style.backgroundColor]="chip"></div>
  }
</div>